export default __webpack_public_path__ + "b04b32ea15a972818c8f72f0a0602e22.png";